// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".project-list-item--_PDwP .project-list-item-link--A33Vv{padding-top:10px !important;padding-bottom:10px !important;display:flex !important;align-items:center}.project-list-item--_PDwP.active-project--R95_8 a,.project-list-item--_PDwP.active-project--R95_8 a:hover,.project-list-item--_PDwP.active-project--R95_8 a:focus{background-color:#d7dae4;color:#5645f5}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"project-list-item": "project-list-item--_PDwP",
	"project-list-item-link": "project-list-item-link--A33Vv",
	"active-project": "active-project--R95_8"
};
export default ___CSS_LOADER_EXPORT___;
